<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="form-floating mb-3">
					<input type="text" class="form-control" id="search" name="search" [(ngModel)]="filters.search" />
					<label for="search">Wyszukiwarka</label>
				</div>
				<div class="mb-3">
					<label for="currentOwnerName" class="mt-3">Użytkownik</label>
					<ng-select
						id="currentOwnerName"
						name="currentOwnerName"
						[(ngModel)]="filters.currentOwnerName"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of currentOwnerName" [value]="item.currentOwnerName">{{
							item.currentOwnerName
						}}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="currentOwnerTransactions" class="mt-3">Osoba odpowiedzialna</label>
					<ng-select
						id="currentOwnerTransactions"
						name="currentOwnerTransactions"
						[(ngModel)]="filters.currentOwnerTransactions"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of currentOwnerName" [value]="item.currentOwnerName">{{
							item.currentOwnerName
						}}</ng-option>
					</ng-select>
				</div>
				<div class="row mb-3">
					<div class="col">
						<div class="form-floating">
							<input
								type="date"
								class="form-control text-center"
								name="date"
								id="date"
								[(ngModel)]="filters.dateFrom"
							/>
							<label for="date">Data od</label>
						</div>
					</div>
					<div class="col">
						<div class="form-floating">
							<input
								type="date"
								class="form-control text-center"
								name="date"
								id="date"
								[(ngModel)]="filters.dateTo"
							/>
							<label for="date">Data do</label>
						</div>
					</div>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="type" name="type" [(ngModel)]="filters.type">
						<option value="">(wszystkie)</option>
						<option value="-1">(puste)</option>
						<option *ngFor="let item of types" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
					<label for="status">Rodzaj transakcji</label>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="objType" name="objType" [(ngModel)]="filters.objType">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of objTypes" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
					<label for="objType">Rodzaj właściciela</label>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="verified" name="verified" [(ngModel)]="filters.verified">
						<option value="">(wszystkie)</option>
						<option value="1">Tak</option>
						<option value="0">Nie</option>
					</select>
					<label for="verified">Rozliczone</label>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="calculated" name="calculated" [(ngModel)]="filters.calculated">
						<option value="">(wszystkie)</option>
						<option value="1">Tak</option>
						<option value="0">Nie</option>
					</select>
					<label for="calculated">Kalkulacja</label>
				</div>
				<div class="form-floating mb-3">
					<select
						class="form-select"
						id="originalDocument"
						name="originalDocument"
						[(ngModel)]="filters.originalDocument"
					>
						<option value="">(wszystkie)</option>
						<option value="1">Tak</option>
						<option value="0">Nie</option>
					</select>
					<label for="originalDocument">Oryginał dokumentu</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-4">
							<button type="button" class="btn btn-secondary" (click)="filtersClear()">
								Wyczyść filtry
							</button>
						</div>
						<div class="col-sm-8 text-end">
							<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
